// src/utils/timeAgo.ts
import { formatDistanceToNow, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';

type DateInput = string | number | Date;

export function timeAgo(input: DateInput): string {
    const d =
        typeof input === 'string' && input.includes(' ')
            ? parseISO(input.replace(' ', 'T'))
            : new Date(input);

    return formatDistanceToNow(d, { addSuffix: true, locale: enUS });
}
